(function () {
  'use strict';

  function hashCode(s) {
    return s.split('').reduce(function (a, b) {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0);
  }

  function random(seed) {
    var x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  }

  function shuffle(array, seed) {
    var m = array.length,
      t,
      i;

    while (m) {
      i = Math.floor(random(seed) * m--);

      t = array[m];
      array[m] = array[i];
      array[i] = t;
      ++seed;
    }

    return array;
  }

  function choose(array) {
    if (!array || array.length === 0) return null;
    return array[Math.floor(Math.random() * array.length)];
  }

  window.CollectionUtils = {
    hashCode: hashCode,
    random: random,
    shuffle: shuffle,
    choose: choose,
  };
})();
